import { render, staticRenderFns } from "./tabUnitLoadDevice.vue?vue&type=template&id=0a145da2&scoped=true&"
import script from "./tabUnitLoadDevice.vue?vue&type=script&lang=js&"
export * from "./tabUnitLoadDevice.vue?vue&type=script&lang=js&"
import style0 from "./tabUnitLoadDevice.vue?vue&type=style&index=0&id=0a145da2&lang=scss&scoped=true&"
import style1 from "./tabUnitLoadDevice.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a145da2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a145da2')) {
      api.createRecord('0a145da2', component.options)
    } else {
      api.reload('0a145da2', component.options)
    }
    module.hot.accept("./tabUnitLoadDevice.vue?vue&type=template&id=0a145da2&scoped=true&", function () {
      api.rerender('0a145da2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/tabUnitLoadDevice.vue"
export default component.exports